import { SummaryModel } from "src/app/modules/common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";

export class ProviderServiceOptionSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel
    name: string;
}

